
import { useEffect, useState } from 'react';
import './Score.css';
const Score = ({vote,id})=>{
    const [score,setScore] = useState(()=>vote)//se passo un valore(anche una funzione), verra eseguitop ogni voltq che renderizzo score (incluso aggiornamento), mentre con una funzione(call back) solo la prima volta
    useEffect(()=>{
      updateScore();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[score])
    function add(){
      setScore(prevScore=>prevScore+1)//meglio passare un funzione, per non sovrascivere
    }  
    function remove(){
      setScore(prevScore=>prevScore-1)
    }
    function updateScore(){
      const data = JSON.parse(localStorage.getItem('data'))
      data.comments.forEach(element => {
        if(element.id===id)
        element.score = score;
        else{
          element.replies.forEach(rep=>{
            if(rep.id===id)
            rep.score = score;
          })
        }
      });
      localStorage.setItem('data',JSON.stringify(data))
    }
    return (
    <div className="score">
      <div className="add" onClick={add}><img src='../../images/icon-plus.svg' alt="+"/></div>
      <div className="vote"><p>{score}</p></div>
      <div className="remove" onClick={remove}><img src='../../images/icon-minus.svg' alt="-"/></div>
      
    </div>
  )
}
export default Score;